/**
 * This script intend to provide basic file function.
 */
import { weather } from "../../../service/API";

// Tools
const geoApi = require("./GeoApi");

/**
 * Retrieve city lat/lng before OpenWeatherMap API call
 * @param { Object } params
 * @returns containing city/units/lang
 */
export function getWeather(params) {
  return new Promise((resolve, reject) => {
    if (params.city.length > 0) {
      if (params.city != "auto") {
        geoApi.getCityInfo(params.city).then((response) => {
          if (response.length > 0) {
            params.city = response[0].nom;
            params.lat = response[0].centre.coordinates[1];
            params.lng = response[0].centre.coordinates[0];
            apiCall(params)
              .then((data) => {
                return resolve(data);
              })
              .catch((err) => {
                return reject(err);
              });
          }
        });
      } else {
        // TODO: need to retrieve player lat/lng before apiCall
        return reject("city set to auto");
      }
    } else {
      return reject("city is empty");
    }
  });
}

/**
 * Create a string description corresponding to the weather code send in parameters
 * @param { int } weatherCode identifier for current weather
 * @returns { String } descrption of the corresponding weather code
 */
function makeDescription(weatherCode) {
  switch (weatherCode) {
    case 0:
      return "Ensoleillé";
    case 1:
    case 2:
    case 3:
      return "Nuageux";
    case 45:
    case 48:
      return "Brouillard";
    case 51:
    case 53:
    case 55:
      return "Bruine";
    case 56:
    case 57:
    case 66:
    case 67:
      return "Pluie verglaçante";
    case 61:
    case 63:
    case 65:
    case 80:
    case 81:
    case 82:
      return "Pluie";
    case 71:
    case 73:
    case 75:
    case 77:
    case 85:
    case 86:
      return "Neige";
    case 95:
    case 96:
    case 99:
      return "Orage";
  }
}

/**
 * Retrieve weather from Open-Meteo API
 * @param { Object } params containing city/lat/lng/units/lang
 * @returns
 */
function apiCall(params) {
  return new Promise((resolve, reject) => {
    weather
      .get(
        "/forecast?latitude=" +
          params.lat +
          "&longitude=" +
          params.lng +
          "&hourly=relativehumidity_2m&daily=weathercode,temperature_2m_max,temperature_2m_min,sunrise,sunset,rain_sum,windspeed_10m_max,winddirection_10m_dominant&timeformat=unixtime&timezone=auto"
      )
      .then((response) => {
        if (response.status == 200) {
          const day_length = response.data.daily.time.length;
          const daily = response.data.daily;
          const hourly = response.data.hourly;
          const result = [];

          for (let i = 0; i < day_length; i++) {
            const day = {
              icon: daily.weathercode[i],
              temp: daily.temperature_2m_max[i],
              city: params.city,
              description: makeDescription(daily.weathercode[i]),
              rain: daily.rain_sum[i],
              humidity: hourly.relativehumidity_2m[12 + i * 24],
              sunrise: daily.sunrise[i],
              sunset: daily.sunset[i],
              wind_direction: daily.winddirection_10m_dominant[i],
              wind_speed: daily.windspeed_10m_max[i],
            };

            result.push(day);
          }

          return resolve(result);
        } else {
          return reject("get weather failed with status : " + response.status);
        }
      })
      .catch((err) => {
        console.error(err);
        return reject("get weather failed with error : " + err);
      });
  });
}
